'use client';

import React, { useState } from 'react';
import { Button } from '@/features/button';
import { IconArrowSquareDown, IconArrowSquareUp, IconStory } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { cn } from '@/utils/cn';
import SectionHeading from './section-heading';
import { useLanguage } from '../context/language-context-provider';
const KhanoumiStory = () => {
  const {
    t,
    language
  } = useLanguage();
  const isEn = language === 'en';
  const {
    isMobile
  } = useMobileDetect();
  const [isShowFullContent, setIsShowFullContent] = useState(false);
  return <div className='homepage-container lg:mt-36' data-sentry-component="KhanoumiStory" data-sentry-source-file="khanoumi-story.tsx">
            <div className='relative flex flex-col items-center rounded border border-border-pink px-3 pb-6 pt-8 lg:px-4.5 lg:pt-16'>
                <SectionHeading icon={<IconStory />} title={t('story.title')} className='absolute -top-4 right-1/2 translate-x-1/2 lg:-top-8' data-sentry-element="SectionHeading" data-sentry-source-file="khanoumi-story.tsx">
                    <span className='absolute -left-7.5 bottom-1/2 -z-10 hidden h-36 w-px bg-border-pink lg:inline-block' />
                </SectionHeading>

                <div>
                    <div className={cn('flex flex-col text-body-14 lg:gap-5 lg:text-body-16', "[&>span:before]:absolute [&>span:before]:top-2 [&>span:before]:h-1 [&>span:before]:w-1 [&>span:before]:rounded-full [&>span:before]:bg-black [&>span:before]:content-[''] [&>span:before]:lg:h-2.5 [&>span:before]:lg:w-2.5 [&>span:before]:lg:bg-primary-main [&>span]:relative [&>span]:block [&>span]:text-justify", {
          'max-h-96 overflow-hidden': !isShowFullContent && isMobile,
          'pb-4': isShowFullContent,
          '[&>span:before]:left-0 [&>span]:pl-4 [&>span]:lg:pl-5': isEn,
          '[&>span:before]:right-0 [&>span]:pr-4 [&>span]:lg:pr-5': !isEn
        })}>
                        <span>{t('story.item1')}</span>
                        <span>{t('story.item2')}</span>
                        <span>{t('story.item3')}</span>
                        <span>{t('story.item4')}</span>
                    </div>

                    {isMobile && !isShowFullContent && <div className='absolute bottom-0 left-0 right-0 h-30 bg-gradient-to-t from-white to-transparent'></div>}

                    {isMobile && <Button graphicStyle='text' size='small' onClick={() => setIsShowFullContent(prev => !prev)} className='absolute bottom-0 right-1/2 translate-x-1/2' icon={{
          element: isShowFullContent ? <IconArrowSquareUp className='h-6 w-6' /> : <IconArrowSquareDown className='h-6 w-6' />,
          position: 'left'
        }}>
                            {t(isShowFullContent ? 'general.showLess' : 'general.showMore')}
                        </Button>}
                </div>
            </div>
        </div>;
};
export default KhanoumiStory;